/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/245-baffled2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M6 6.5a.5.5 0 11-1 0 .5.5 0 011 0zM11 6.5a.5.5 0 11-1 0 .5.5 0 011 0z"/><path pid="1" d="M8 0a8 8 0 100 16A8 8 0 008 0zM4 6.5a1.5 1.5 0 113.001.001A1.5 1.5 0 014 6.5zm6 5.5H6v-1h4v1zm.5-4a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0110.5 8z"/>'
  }
})
